import React from 'react'
import logoBlack from '../../../assets/Avothar-black-logo.png';

const Footer = () => {

  const styles = {
    footer: {
      background: "#f8f9fa",
      borderTop: "1px solid #e5e5e5",
      fontSize: "14px"
    },

    logo: {
      width: "150px",
      height: "auto",
      objectFit: "contain"
    },

    link: {
      color: "#1a73e8",
      fontSize:"16px",
      fontWeight: "600",
      borderBottom: "2px solid transparent",
      transition: "all 0.3s ease"
    },

    brassyLink: {
      color: "#1a73e8",
      fontSize:"16px",
      fontWeight: "600",
      borderBottom: "2px solid transparent",
      transition: "all 0.3s ease"
    }
  }

  return (
    <footer style={styles.footer}>
      <div className="container py-4">

        {/* Top Row */}
        <div className="row mx-md-5 align-items-center text-center text-lg-start">

          <div className="col-lg-3 mb-3 mb-lg-0">
            <a className="navbar-brand logo-brand" href="https://avothar.com/">
              <img
                src={logoBlack}
                alt="Avothar logo"
                style={styles.logo}
                loading="lazy"
              />
            </a>
          </div>

          <div className="col-lg-3">
            <h6>Kodaikanal</h6>
          </div>

          <div className="col-lg-3">
            <h6>info@Avothar.com</h6>
          </div>

          <div className="col-lg-3">
            <h6>+91 98845 90109</h6>
          </div>

        </div>

        <hr />

        {/* Bottom Row */}
        <div className="row align-items-center my-4">

          <div className="col-md-6 text-center text-md-start">
            <p className="mb-0">
              Designed & Developed by
              <a
                href="https://brassyacademy.com/"
                target="_blank"
                rel="noreferrer"
                style={styles.brassyLink}
                className="ms-1"
              >
                Brassy Academy
              </a>
            </p>
          </div>

          <div className="col-md-6 text-center text-md-end">
            <p className="mb-0">
              © Avothar powered by
              <a
                href="https://kodaiagriorg.com"
                style={styles.link}
                className="ms-1"
              >
                Kodai Agriorg
              </a>
            </p>
          </div>

        </div>

      </div>
    </footer>
  )
}

export default Footer